<template>
  <div class="createPlayStep">
    <div class="backBox">
      <img class="pointer" @click="clickLocalStep()" src="@/assets/thdImg/pages/back.svg" alt="" />
      <span class="backBox_name">{{ activityData.name }}</span>
    </div>
    <div class="formBox">
      <!-- 步骤条 -->
      <div class="stepBox">
        <el-steps class="bz" :space="300" :active="1">
          <el-step title="活动模板"></el-step>
          <el-step title="设置规则"></el-step>
          <el-step title="完成发布"></el-step>
        </el-steps>
      </div>
      <!-- 活动条件表单设置 -->
      <div class="secondstep">
        <el-form :model="ruleForm" :rules="rules" ref="ruleForm" class="backgroundForm" label-width="120px">
          <el-form-item label="活动名称:" required>
            <!-- prop="activityName" 活动名称 -->
            <el-input v-model="ruleForm.activityName" maxlength="50" show-word-limit placeholder="请输入活动名称" style="width: 340px"></el-input>
          </el-form-item>

          <el-form-item label="活动时间:" required>
            <!-- prop="isLongTime" 活动开始时间-活动结束时间 -->
            <div class="my_select_time">
              <el-date-picker
                v-model="activityTimeValue"
                type="datetimerange"
                class="rangeTime"
                format="yyyy-MM-dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
                ref="timeBox"
                @change="activityTimeChange"
                style="width: 340px; font-size: 12px"
                :picker-options="pickerOptionsValue"
                :default-time="defaultTime"
              >
              </el-date-picker>
              <i class="el-icon-circle-close date_icon1" @click="activityTimeValue = []"></i>
              <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
            </div>
            <span class="lastTime" style="color: #666">
              活动持续 <span style="color: #2670fb">{{ timeDay }}</span> 天 <span style="color: #2670fb">{{ timeOut }}</span> 小时
              <el-tooltip class="item" effect="light" content="活动有效期不可超过订购有效期" placement="bottom">
                <el-button type="text" style="width: 35px;">
                  <i class="el-icon-question"></i>
                </el-button>
              </el-tooltip>
            </span>
          </el-form-item>

          <el-form-item label="活动对象:" required>
            <el-radio-group
              v-model="ruleForm.activityObject"
              :disabled="backgroundOpacity || isStartEdit"
              @change="handleActivityObj"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">指定身份</el-radio>
              <el-radio :label="2" disabled>指定人群</el-radio>
            </el-radio-group>
            <el-popover
                placement="right-start"
                trigger="hover"
                content="您不满足使用该功能的条件，请联系专属客服了解~"
              >
                <el-button slot="reference" disabled style="margin-left:16px">{{
                  peopleList.length == 0
                    ? "选择人群"
                    : `已选${peopleList.length}个`
                }}</el-button>
              </el-popover>
          </el-form-item>
          <el-form-item
            label="新老客户:"
            required
            v-if="ruleForm.activityObject == '1'"
          >
            <el-radio-group
              v-model="ruleForm.newOldCustomer"
              :disabled="backgroundOpacity || isStartEdit"
            >
              <el-radio :label="0">不限</el-radio>
              <el-radio :label="1">新客</el-radio>
              <el-radio :label="2">老客</el-radio>
            </el-radio-group>
            <el-tooltip effect="light" placement="top-start">
              <div slot="content">
                1、历史订单中已完成订单的订单数为0则定义为新客<br />2、历史订单中已完成订单的订单数≥1则定义为新客
              </div>
              <div
                class="cursorPointer"
                style="
                  display: inline-block;
                  margin-left: 16px;
                  font-size: 12px;
                  color: #ccc;
                "
              >
                <span style="color:#999">新老客说明</span>
                <i class="el-icon-question"></i>
              </div>
            </el-tooltip>
          </el-form-item>
          <el-form-item
            label="参与对象:"
            prop="partner"
            v-if="ruleForm.activityObject == '1'"
          >
            <el-checkbox-group
              v-model="ruleForm.partner"
              @change="checkListchange"
              :disabled="backgroundOpacity || isStartEdit"
            >
              <el-checkbox label="-1" name="partner">全部</el-checkbox>
              <el-checkbox
                label="0"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >非会员</el-checkbox
              >

              <el-checkbox
                v-for="(item, index) in levelList"
                :key="index"
                :label="index + 1 + ''"
                name="partner"
                :disabled="ruleForm.partner == -1"
                >{{ item }}</el-checkbox
              >
            </el-checkbox-group>
          </el-form-item>

          <el-form-item
            label="入会时间:"
            v-if="ruleForm.activityObject == '1' && ruleForm.partner != 0"
          >
          <el-date-picker
            v-model="ruleForm.membershipTime"
            format="yyyy-MM-dd HH:mm:ss"
            value-format="yyyy-MM-dd HH:mm:ss"
            start-placeholder="开始日期"
            type="datetime"
            :disabled="backgroundOpacity || isStartEdit"
            placeholder="选择日期时间">
          </el-date-picker>
          之后成为会员的用户可参与活动
          </el-form-item>

          <el-form-item label="活动条件:" >
            <!-- prop="isFollow" 是否关注店铺 -->
            <el-checkbox :disabled="isStartEdit" label="关注店铺后方可参与活动" v-model="ruleForm.condFollow"></el-checkbox>
          </el-form-item>

          <el-form-item label="抽奖条件:" required>
            <el-checkbox :disabled="isStartEdit" @change="isPointChange()" v-model="isPoint"></el-checkbox>
            <!-- prop="term" -->
            用户消耗
            <el-input :disabled="isStartEdit" v-model.number="bigTurntable.point" placeholder="请输入..." style="width: 80px" @input="bigTurntable.point = getNumberData($event, 0)"></el-input>
            积分抽奖一次
          </el-form-item>

          <!-- Note-----大转盘添加每日赠送 -->
          <el-form-item label="">
            <el-checkbox v-model="isGift" @change="isStartEditChange()" :disabled="isStartEdit"></el-checkbox> 每日赠送
            <el-input :disabled="isStartEdit" v-model.number="bigTurntable.giftDrawNumber" placeholder="请输入..." style="width: 80px" @input="bigTurntable.giftDrawNumber = getNumberData($event, 0)"></el-input>
            次免费抽奖次数（按自然日赠送）
          </el-form-item>

          <el-form-item label="">
            <div style="display: flex;">
            <div><el-checkbox :disabled="isStartEdit" @change="isTaskchange" v-model="isTask" style="margin-right: 4px;"></el-checkbox>额外抽奖任务：</div>
              <el-form>
              <div style="margin:0 0 12px 0;color:#666666;background: #F4F7FF;border-radius: 4px;padding: 5px 15px;">
                <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:0px"></i>
                注：通过以下任务获得的抽奖次数，用户获取成功后，无须消耗积分即可进行抽奖。但是会算入用户抽奖次数限制
              </div>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[0].interests" :disabled="isStartEdit"></el-checkbox>
                关注店铺后，赠送
                <el-input 
                  :disabled="isStartEdit"
                  v-model.number="extraPriceTask[0].interestsVal"
                  placeholder="请输入..."
                  style="width: 80px"
                  @input="extraPriceTask[0].interestsVal = getNumberData($event, 0)"
                >
                </el-input>
                次抽奖机会
              </el-form-item>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[1].newCustomer" :disabled="isStartEdit"></el-checkbox>
                新客赠送：在店铺一年内（365天）不含已付款订单的客户，赠送
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="extraPriceTask[1].newCustomerVal"
                  placeholder="请输入..."
                  style="width: 80px"
                  @input="extraPriceTask[1].newCustomerVal = getNumberData($event, 0)"
                >
                </el-input>
                次抽奖机会
              </el-form-item>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[2].oldCustomer" :disabled="isStartEdit"></el-checkbox>
                老客赠送：在店铺一年内（365天）含已付款订单的客户，赠送
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="extraPriceTask[2].oldCustomerVal"
                  placeholder="请输入..."
                  style="width: 80px"
                  @input="extraPriceTask[2].oldCustomerVal = getNumberData($event, 0)"
                >
                </el-input>
                次抽奖机会
              </el-form-item>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[3].member" :disabled="isStartEdit"></el-checkbox>
                会员赠送：成为会员后，赠送
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="extraPriceTask[3].memberVal"
                  placeholder="请输入..."
                  style="width: 80px"
                  @input="extraPriceTask[3].memberVal = getNumberData($event, 0)"
                >
                </el-input>
                次抽奖机会
              </el-form-item>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[4].preSale" :disabled="isStartEdit"></el-checkbox>
                预售商品支付定金赠送
                <el-form
                  style="padding: 8px;border:#ccc 1px solid;"
                  v-model="extraPriceTask[4]"
                >
                  <el-form-item required label="赠送说明：">
                    在
                    <div class="my_select_time">
                      <el-date-picker
                        v-model="extraPriceTask[4].time"
                        type="datetimerange"
                        class="rangeTime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        ref="timeBox"
                        style="width: 340px; font-size: 12px"
                        :disabled="isStartEdit"
                      >
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="extraPriceTask[4].time = []"></i>
                      <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                    </div>
                    订单付款时间内，预售订单支付定金成功后，赠送
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="extraPriceTask[4].preSaleVal"
                      placeholder="请输入..."
                      style="width: 80px"
                      @input="extraPriceTask[4].preSaleVal = getNumberData($event, 0)"
                    >
                    </el-input>
                    次抽奖机会
                  </el-form-item>
                  <el-form-item label="参与条件：">
                    <el-radio-group v-model="extraPriceTask[4].handinCondition" :disabled="isStartEdit">
                      <el-radio :label="0">全部商品</el-radio>
                      <el-radio :label="1">单笔订单必须包含指定商品
                        <el-button
                          :disabled="extraPriceTask[4].handinCondition != 1 || isStartEdit"
                          @click="exposureProductsFiter(4)"
                        >
                          <template v-if="extraPriceTask[4].handinConditionList&&extraPriceTask[4].handinConditionList.length">
                            {{ "已选择" + "(" + extraPriceTask[4].handinConditionList.length + "个)" }}
                          </template>
                          <template v-else>
                            +添加
                          </template>
                        </el-button>
                      </el-radio>
                      <selectGoodsMonitor
                        v-if="extraPriceTask[4].selectGoodsStateFilter"
                        @transferName="selectTask4GoodsCloseFilter"
                        :postForm="extraPriceTask[4].handinConditionList"
                        :maxNum="20"
                      />
                      <el-radio :label="2">单笔订单排除商品（如订单中含排除商品，则该笔订单不计入）
                        <el-button
                          :disabled="extraPriceTask[4].handinCondition != 2 || isStartEdit"
                          @click="exposureProductsFiterEx(4)"
                        >
                          <template v-if="extraPriceTask[4].handinConditionListEx&&extraPriceTask[4].handinConditionListEx.length">
                            {{ "已选择" + "(" + extraPriceTask[4].handinConditionListEx.length + "个)" }}
                          </template>
                          <template v-else>
                            +添加
                          </template>
                        </el-button>
                      </el-radio>
                      <selectGoodsMonitor
                        v-if="extraPriceTask[4].selectGoodsStateFilterEx"
                        @transferName="selectTask4GoodsCloseFilterEx"
                        :postForm="extraPriceTask[4].handinConditionListEx"
                        :maxNum="20"
                      />
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="赠送限制：">
                    <el-radio-group v-model="extraPriceTask[4].feedBackCondition" :disabled="isStartEdit">
                      <el-radio :label="0">每个用户限送一次</el-radio>
                      <el-radio :label="1">符合条件的订单都送（如：有三个符合条件的预售订单，则赠送3次）</el-radio>
                    </el-radio-group>
                  </el-form-item>
                </el-form>
              </el-form-item>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[5].costPayFeedback" :disabled="isStartEdit"></el-checkbox>
                消费赠送（已付款）
                <div style="margin:0 0 12px 0;color:#666666;background: #F4F7FF;border-radius: 4px;padding: 5px 15px;">
                  <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:0px"></i>
                  （包含非预售下单付全款 和预售付尾款两种阶段；已发货和确认收货的订单也能获得此抽奖机会）
                </div>
                <el-form
                  style="padding: 8px;border:#ccc 1px solid;"
                  v-model="extraPriceTask[5]"
                >
                  <el-form-item required label="赠送说明：">
                    在
                    <div class="my_select_time">
                      <el-date-picker
                        :disabled="isStartEdit"
                        v-model="extraPriceTask[5].time"
                        type="datetimerange"
                        class="rangeTime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        ref="timeBox"
                        style="width: 340px; font-size: 12px"
                      >
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="extraPriceTask[5].time = []"></i>
                      <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                    </div>
                    时间内产生订单且订单状态为已付款赠送
                  </el-form-item>
                  <el-form-item label="参与条件：">
                    <el-radio-group v-model="extraPriceTask[5].handinCondition" :disabled="isStartEdit">
                      <el-radio :label="0">全部商品</el-radio>
                      <el-radio :label="1">单笔订单必须包含指定商品
                        <el-button
                          :disabled="extraPriceTask[5].handinCondition != 1 || isStartEdit"
                          @click="exposureProductsFiter(5)"
                        >
                          <template v-if="extraPriceTask[5].handinConditionList&&extraPriceTask[5].handinConditionList.length">
                            {{ "已选择" + "(" + extraPriceTask[5].handinConditionList.length + "个)" }}
                          </template>
                          <template v-else>
                            +添加
                          </template>
                        </el-button>
                      </el-radio>
                      <selectGoodsMonitor
                        v-if="extraPriceTask[5].selectGoodsStateFilter"
                        @transferName="selectTask5GoodsCloseFilter"
                        :postForm="extraPriceTask[5].handinConditionList"
                        :maxNum="20"
                      />
                      <el-radio :label="2">单笔订单排除商品（如订单中含排除商品，则该笔订单不计入）
                        <el-button
                          :disabled="extraPriceTask[5].handinCondition != 2 || isStartEdit"
                          @click="exposureProductsFiterEx(5)"
                        >
                          <template v-if="extraPriceTask[5].handinConditionListEx&&extraPriceTask[5].handinConditionListEx.length">
                            {{ "已选择" + "(" + extraPriceTask[5].handinConditionListEx.length + "个)" }}
                          </template>
                          <template v-else>
                            +添加
                          </template>
                        </el-button>
                      </el-radio>
                      <selectGoodsMonitor
                        v-if="extraPriceTask[5].selectGoodsStateFilterEx"
                        @transferName="selectTask5GoodsCloseFilterEx"
                        :postForm="extraPriceTask[5].handinConditionListEx"
                        :maxNum="20"
                      />
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="赠送限制：">
                    <el-radio-group v-model="extraPriceTask[5].feedBackCondition" :disabled="isStartEdit">
                      <el-radio :label="0">每个用户限送一次</el-radio>
                      <el-radio :label="1">符合条件的订单都送</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="赠送次数：">
                    单笔订单实付金额满
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="extraPriceTask[5].timesCondition1"
                      placeholder="请输入..."
                      style="width: 80px"
                      @input="extraPriceTask[5].timesCondition1 = getNumberData($event, 0)"
                    >
                    </el-input>
                    元以上都是固定赠送
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="extraPriceTask[5].timesCondition2"
                      placeholder="请输入..."
                      style="width: 80px"
                      @input="extraPriceTask[5].timesCondition2 = getNumberData($event, 0)"
                    >
                    </el-input>
                    次抽奖机会
                  </el-form-item>
                </el-form>
              </el-form-item>
              <el-form-item v-show="isTask">
                <el-checkbox @change="taskListChange" v-model="extraPriceTask[6].costReceiFeedback" :disabled="isStartEdit"></el-checkbox>
                消费赠送（已收货）
                <el-form
                  style="padding: 8px;border:#ccc 1px solid;"
                  v-model="extraPriceTask[5]"
                >
                  <el-form-item required label="赠送说明：">
                    在
                    <div class="my_select_time">
                      <el-date-picker
                       :disabled="isStartEdit"
                        v-model="extraPriceTask[6].time"
                        type="datetimerange"
                        class="rangeTime"
                        format="yyyy-MM-dd HH:mm:ss"
                        value-format="yyyy-MM-dd HH:mm:ss"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        ref="timeBox"
                        style="width: 340px; font-size: 12px"
                      >
                      </el-date-picker>
                      <i class="el-icon-circle-close date_icon1" @click="extraPriceTask[6].time = []"></i>
                      <img src="@/assets/images/select_date.svg" alt="" class="date_icon2" />
                    </div>
                    时间内产生订单且订单状态为已收货赠送
                  </el-form-item>
                  <el-form-item label="参与条件：">
                    <el-radio-group v-model="extraPriceTask[6].handinCondition" :disabled="isStartEdit">
                      <el-radio :label="0">全部商品</el-radio>
                      <el-radio :label="1">单笔订单必须包含指定商品
                        <el-button
                          :disabled="extraPriceTask[6].handinCondition != 1 || isStartEdit"
                          @click="exposureProductsFiter(6)"
                        >
                          <template v-if="extraPriceTask[6].handinConditionList&&extraPriceTask[6].handinConditionList.length">
                            {{ "已选择" + "(" + extraPriceTask[6].handinConditionList.length + "个)" }}
                          </template>
                          <template v-else>
                            +添加
                          </template>
                        </el-button>
                      </el-radio>
                      <selectGoodsMonitor
                        v-if="extraPriceTask[6].selectGoodsStateFilter"
                        @transferName="selectTask6GoodsCloseFilter"
                        :postForm="extraPriceTask[6].handinConditionList"
                        :maxNum="20"
                      />
                      <el-radio :label="2">单笔订单排除商品（如订单中含排除商品，则该笔订单不计入）
                        <el-button
                          :disabled="extraPriceTask[6].handinCondition != 2 || isStartEdit"
                          @click="exposureProductsFiterEx(6)"
                        >
                          <template v-if="extraPriceTask[6].handinConditionListEx&&extraPriceTask[6].handinConditionListEx.length">
                            {{ "已选择" + "(" + extraPriceTask[6].handinConditionListEx.length + "个)" }}
                          </template>
                          <template v-else>
                            +添加
                          </template>
                        </el-button>
                      </el-radio>
                      <selectGoodsMonitor
                        v-if="extraPriceTask[6].selectGoodsStateFilterEx"
                        @transferName="selectTask6GoodsCloseFilterEx"
                        :postForm="extraPriceTask[6].handinConditionListEx"
                        :maxNum="20"
                      />
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="赠送限制：">
                    <el-radio-group v-model="extraPriceTask[6].feedBackCondition" :disabled="isStartEdit">
                      <el-radio :label="0">每个用户限送一次</el-radio>
                      <el-radio :label="1">符合条件的订单都送</el-radio>
                    </el-radio-group>
                  </el-form-item>
                  <el-form-item label="赠送次数：">
                    单笔订单实付金额满
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="extraPriceTask[6].timesCondition1"
                      placeholder="请输入..."
                      style="width: 80px"
                      @input="extraPriceTask[6].timesCondition1 = getNumberData($event, 0)"
                    >
                    </el-input>
                    元以上都是固定赠送
                    <el-input
                      :disabled="isStartEdit"
                      v-model.number="extraPriceTask[6].timesCondition2"
                      placeholder="请输入..."
                      style="width: 80px"
                      @input="extraPriceTask[6].timesCondition2 = getNumberData($event, 0)"
                    >
                    </el-input>
                    次抽奖机会
                  </el-form-item>
                </el-form>
              </el-form-item>
            </el-form>
          </div>
          </el-form-item>

          <el-form-item label="抽奖和中奖限制:">
            <div class="limit">
              <p>
                每人<span class="c">每天</span>最多抽奖次数
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="bigTurntable.oneDayMaxDrawNumber"
                  placeholder="请输入..."
                  @input="bigTurntable.oneDayMaxDrawNumber = getNumberData($event, 0)"
                  style="width: 70px"
                ></el-input>
                次, 活动期间<span class="c">累计抽奖</span>最多
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="bigTurntable.totalMaxDrawNumber"
                  placeholder="请输入..."
                  @input="bigTurntable.totalMaxDrawNumber = getNumberData($event, 0)"
                  style="width: 70px"
                ></el-input>
                次,
              </p>
              <p>
                活动期间每人<span class="c">每天</span>中奖不超过
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="bigTurntable.oneDayMaxRewardNumber"
                  placeholder="请输入..."
                  style="width: 70px"
                  @input="bigTurntable.oneDayMaxRewardNumber = getNumberData($event, 0)"
                ></el-input>
                次, <span class="c">累计</span>中奖不超过
                <el-input
                  :disabled="isStartEdit"
                  v-model.number="bigTurntable.totalMaxRewardNumber"
                  placeholder="请输入..."
                  style="width: 70px"
                  @input="bigTurntable.totalMaxRewardNumber = getNumberData($event, 0)"
                ></el-input>
                次,
              </p>
              <!-- <p class="desc">
                <img
                  src="@/assets/images/new_icon_reminder1.png"
                  style="
                    display: inline-block;
                    float: left;
                    width: 14px;
                    height: 14px;
                    color: #ffffff;
                    margin: 9px 4px 0 3px;
                  "
                />
                此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
              </p> -->
              <div style="margin:12px 0 0 0px;color:#666666;background: #F4F7FF;border-radius: 4px;width: 511px;padding: 5px 15px;">
                <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:0px"></i>
                注：此处是对抽奖次数和中奖次数做限制。上面次数不填写，表示不限制
              </div>
            </div>
          </el-form-item>

          <el-form-item required>
            <span slot="label" class="set">奖品设置:</span>
            <div class="termAdd">
              <el-popover placement="right" width="270" trigger="hover">
                <img src="../../assets/images/integralCenter/wzsyt.png" alt="" />
                <span slot="reference">位置示意图</span>
              </el-popover>
              <p>
                累计中奖率: <span class="add">{{ winningRate }} %</span>
              </p>
            </div>
            <el-table
              :data="prizeSettingList"
              style="width: 100%; border: 1px solid #f0f0f0"
              :header-cell-style="{ background: '#F8F9FF', 'text-align': 'left' }"
              :cell-style="{ 'text-align': 'left' }"
            >
              <el-table-column label="位置">
                <template slot-scope="scope">
                  <span v-if="scope.row.index == 0">一</span>
                  <span v-if="scope.row.index == 1">二</span>
                  <span v-if="scope.row.index == 2">三</span>
                  <span v-if="scope.row.index == 3">四</span>
                  <span v-if="scope.row.index == 4">五</span>
                  <span v-if="scope.row.index == 5">六</span>
                  <span v-if="scope.row.index == 6">七</span>
                  <span v-if="scope.row.index == 7">八</span>
                </template>
              </el-table-column>

              <el-table-column label="选择奖品">
                <template slot-scope="scope">
                  <span class="s" @click="centerVis(scope.row)">选奖品</span>
                </template>
              </el-table-column>

              <el-table-column label="奖品类型">
                <template slot-scope="scope">
                  <span v-if="scope.row.prizeType == 1">优惠券</span>
                  <span v-if="scope.row.prizeType == 2">京豆</span>
                  <span v-if="scope.row.prizeType == 3">实物</span>
                  <span v-if="scope.row.prizeType == 4">店铺积分</span>
                  <span v-if="scope.row.prizeType == 5">京东E卡</span>
                  <span v-if="scope.row.prizeType == 6">爱奇艺会员</span>
                  <span v-if="scope.row.prizeType == 7">京东PLUS会员</span>
                  <span v-if="scope.row.prizeType == 8">现金红包</span>
                  <span v-if="scope.row.prizeType == 9">谢谢参与</span>
                  <span v-if="scope.row.prizeType == 10">专属商品</span>
                </template>
              </el-table-column>

              <el-table-column label="值" width="80" prop="price">
                <!-- <template slot-scope="scope">
                  {{ scope.row.price }}
                </template> -->
              </el-table-column>

              <el-table-column label="奖品名称（12字内）" width="299">
                <template slot-scope="scope">
                  <el-input :disabled="isStartEdit" v-model="scope.row.title" maxlength="12" show-word-limit style="width: 240px"></el-input>
                </template>
              </el-table-column>

              <el-table-column label="奖品总数" width="180">
                <template slot-scope="scope">
                  <el-input
                    @blur="beAdd(scope.row)"
                    v-model.number="scope.row.totalAmount"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.totalAmount = checkLimitMount(scope.row,1)"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="每日发放限额" width="180">
                <template slot-scope="scope">
                  <el-input
                    v-model.number="scope.row.dailyLimit"
                    placeholder="请输入..."
                    style="width: 70px"
                    @input="scope.row.dailyLimit = checkLimit(scope.row,1)"
                    :disabled="activityData.isStart"
                  ></el-input>
                  份
                </template>
              </el-table-column>

              <el-table-column label="中奖率">
                <template slot-scope="scope">
                  <el-input
                    :disabled="isStartEdit"
                    v-model="scope.row.percentage"
                    placeholder="请输入..."
                    style="width: 70px"
                    @keyup.native="scope.row.percentage = oninput2(scope.row.percentage)"
                    @input="scope.row.percentage = getNumberData($event, 1, 0, 100)"
                  ></el-input>
                  %
                </template>
              </el-table-column>

              <el-table-column label="图片" width="170">
                <template slot-scope="scope">
                  <!-- <div v-if="scope.row.logo">
                    <el-upload
                      ref="upload"
                      action="#"
                      list-type="picture-card"
                      :on-change="handleChange"
                      :on-remove="handleRemove"
                      :http-request="httpRequest" 
                    > -->
                  <img v-if="scope.row.logo" :src="scope.row.logo" style="width: 56px; height: 56px" />
                  <!-- <i class="el-icon-plus" v-else></i> -->
                  <!-- </el-upload> -->
                  <!-- <img
                      :src="scope.row.logo"
                      alt=""
                      class="imgTp"
                      style="width: 100%; height: 100%"
                    /> -->
                  <!-- </div> -->
                </template>
              </el-table-column>

              <el-table-column label="操作">
                <template slot-scope="scope">
                  <span class="s" style="color:#F56C6C" @click="cleanData(scope.row)">清除</span>
                </template>
              </el-table-column>
            </el-table>
            <div class="tips">
              <span> <i class="el-alert__icon el-icon-info" style="color:#2670fb;margin-right:3px"></i>说明 </span>
              <p>
                1、最多设置8个奖项；设置的奖项不足8个时，系统自动补充“谢谢参与”
              </p>
              <p>
                2、中奖率相加不得超过100%，不足100%的时候剩余部分分配给“谢谢参与”
              </p>
              <p>3、中奖率精确到小数点后三位，如不想中奖可设置0%</p>
              <p>
                4、实物奖品可上传图片，不上传使用默认图片。已有图片时点击可更换。
              </p>
            </div>
          </el-form-item>
          <el-form-item label="曝光商品:" prop="exposure" class="zindexBox">
            <el-checkbox v-model="ruleForm.exposureSwitch">
              是否添加曝光商品
            </el-checkbox>
            <el-button
              style="width: 155px; margin: 0 15px"
              @click="exposureProducts"
              :disabled="ruleForm.exposureSwitch == false"
            >
              {{
                itemListFor.length != ""
                  ? "添加曝光商品" + "(" + itemListFor.length + "/20" + ")"
                  : "添加曝光商品"
              }}
            </el-button>
            <draggable
              v-if="itemListFor.length > 0"
              v-model="mainImagelist"
              chosen-class="chosen"
              :scroll="true"
              animation="150"
              force-fallback="true"
              @start="isDragging = true"
              @end="onEnd"
              style="margin-top: 10px;background: rgba(38,112,251,0.06);padding: 10px 10px 0px 10px;"
            >
              <transition-group type="transition">
                <div
                  v-for="(item, index) in mainImagelist"
                  :key="item.skuId"
                  style="display: inline-block; position: relative"
                  class="show_upImg2"
                >
                  <img
                    :src="item.logo"
                    width="120px"
                    height="120px"
                    style="display: inline-block"
                  />&nbsp;
                  <div class="delectPosible">
                    <span class="delectSort">拖动排序</span>
                    <img
                      src="@/assets/thdImg/pages/delet.svg"
                      @click.stop="delec(item, index)"
                      class="delectIcom"
                    />
                  </div>
                </div>
              </transition-group>
            </draggable>
          </el-form-item>
          <el-form-item label="活动规则:" required>
            <div
              style="
                width: 500px;
                padding: 8px;
                    background: #F9FAFB;
              "
            >
              <el-input
                maxlength="2000"
                type="textarea"
                class="textarea"
                style="width: 484px"
                resize="none"
                :disabled="backgroundOpacity"
                v-model="ruleForm.ruleDescription"
              ></el-input>

              <div>
                <el-button type="primary" class="generate" plain @click="generateRule">生成规则</el-button>
                <span class="desc">
                  <i class="el-alert__icon el-icon-info" style="color:#999"></i>
                  点击按钮自动生成规则，也可以自己编辑信息
                </span>
              </div>
            </div>
          </el-form-item>

          <div v-if="backgroundOpacity" class="backgroundOpacity" style="height: calc(100% - 45px);"></div>
        </el-form>
      </div>
    </div>

    <div class="create_bottom">
      <el-button v-show="!itemId" class="createBtn create_bottom_returnBtn" size="medium" @click="clickLocalStep()">{{
        backgroundOpacity ? "返回列表" : "返回上一步"
      }}</el-button>
      <template v-if="!backgroundOpacity">
        <el-button
          v-show="!itemId"
          v-if="isSave"
          class="createBtn create_bottom_keepBtn"
          type="primary"
          size="medium"
          @click="resetForm"
          v-preventReClick
          >保存设置</el-button
        >
      </template>
      <el-button v-show="itemId" class="createBtn create_bottom_returnBtn" size="medium" @click="cancelEdit">取消</el-button>
      <el-button v-show="itemId" class="createBtn create_bottom_keepBtn" type="primary" size="medium">保存设置</el-button>
    </div>
    <!-- 选择奖品弹窗 -->
    <selectProduct ref="selectProduct" :num="1" :JingdouCount="JingdouCount" @choose-shop="getTheData"> </selectProduct>

    <!-- 添加曝光商品 -->
    <selectGoodsMonitor
      ref="selectGo"
      v-if="selectGoodsState"
      @transferName="selectGoodsClose"
      :postForm="selectGoodsArr"
      :maxNum="20"
    >
    </selectGoodsMonitor>

    <!-- 保存并完成设置弹框 -->
    <el-dialog title="重要提示" :visible.sync="joinBlackList" width="800">
      <div style="line-height: 25px; margin-bottom: 30px">
        <p>
          1、活动流量不可控，为避免因奖品发放超出预算造成损失，请检查是否填写各奖品数量限制；仔细核对当前活动内容和活动规则设置，明确活动成本预算；
        </p>
        <p>
          2、活动开始后，请不要随意变更活动规则，避免因活动规则修改导致客诉。
        </p>
      </div>

      <el-checkbox v-model="checked" label="地址" name="partner">我已知晓当前活动内容设置，明确本次活动规则。</el-checkbox>
      <div slot="footer" class="dialog-footer">
        <el-button @click="joinBlackList = false">取 消</el-button>
        <el-button @click="handleDialogCloseAnoth()" type="primary">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import selectProduct from "./select_product";
import QRCode from "qrcodejs2";
import { bigTurntableDraw, modifyBigTurn, getbigTurn } from "@/api/paradiseAndTaskCommonController.js";
import selectGoodsMonitor from "@/components/selectGoodsMonitor";
import draggable from "vuedraggable";

import { uploadpic } from "@/api/paradiseAndTaskCommonController.js";
import { querymemberLevel } from "@/api/integralCenter/memberLevel";

export default {
  components: {
    selectProduct,
    selectGoodsMonitor,
    draggable,
  },
  // props: {
  //   itemId: "",
  //   stepNum: {
  //     type: Number,
  //     default: 0,
  //   },
  //   activityData: {
  //     type: Object,
  //   },
  //   ids: {
  //     type: String,
  //     default: "",
  //   },
  //   isSave: {
  //     type: Boolean,
  //     default: true,
  //   },
  //   backgroundOpacity: {
  //     type: Boolean,
  //     default: false,
  //   },
  // },
  watch: {
    theNum(newName, oldName) {
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      this.winningRate = this.winningRate.toFixed(3);
    },
  },
  data() {
    return {
      isTask:false,
      isPoint:false,
      isStartEditTime:'',
      isStartEdit:false,
      isCopy: false,
      draggingId: [], //有拖拽时要传的ID顺序
      mainImagelist: [], //图片拖拽排序
      isDragging: false,
      itemListFor: [], //商品弹框选择商品数据
      showDialog: false, // 选择奖品弹窗
      selectGoodsState: false, // 曝光商品弹窗
      selectGoodsArr: [], // 曝光商品列表
      generalCoupon: {
        // 通用优惠券
        couponType: 0,
      },
      isGift: false,
      ids: "",
      valueRow: null,
      telCode: "",
      localStep: 1,
      statusComment: false,
      localStepNum: 1,
      activityData: {
        id: 132,
      },
      activeValue: null,
      itemId: "",
      backgroundOpacity: false,
      isSave: true,
      stepNum: 1,
      //
      defaultTime: [this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length), this.$getDate(30)[0].substring(11, this.$getDate(30)[0].length)],
      activityTimeValue: this.$getDate(30),
      pickerOptionsValue: {
        disabledDate: (time) => {
          return time.getTime() < Date.now() - 8.64e7 || time.getTime() > new Date(this.$store.state.loginUserInfo.expiredIn).valueOf();
        },
      },
      JingdouCount: {
        prizeCount: 0,
      },
      qrcode: null,
      joinBlackList: false,
      checked: false,
      winningRate: 0,
      // localStepNum: this.stepNum, // 将外部传入的步骤赋值到本地，避免直接更改props
      rules: {
        // 表单规则校验
        activityName: [
          { required: true, message: "请输入活动名称", trigger: "blur" },
          {
            min: 3,
            max: 50,
            message: "长度在 3 到 50 个字符",
            trigger: "blur",
          },
        ],
        term: [{ required: true, message: "请填写抽奖条件", trigger: "blur" }],
        isLongTime: [{ required: true, message: "请选择活动时间", trigger: "change" }],
        ruleDescription: [{ required: true, message: "请填写活动规则", trigger: "blur" }],
      },
      ruleForm: {
        membershipTime:"",
        activityName: "",
        startTime: "",
        endTime: "",
        condFollow: false,
        ruleDescription: "",
        exposureSwitch: false,

        activityObject: 0, //活动对象
        newOldCustomer: 0, //新老客
        partner: ["-1"],

      },
      peopleList: [], //指定人群
      isShowSelectCrowd: false, //指定人群弹窗
      levelList: [], //会员等级

      bigTurntable: {
        point: null,
        giftDrawNumber: null, //每日赠送
        oneDayMaxDrawNumber: null,
        totalMaxDrawNumber: null,
        oneDayMaxRewardNumber: null,
        totalMaxRewardNumber: null,
      },
      bigTurntableDrawS: [
        // {
        //   assetsId: 0,
        //   logo: "string",
        //   giftType: 0,
        //   logo: "string",
        //   percentage: 0,
        //   price: 0,
        //   prizeType: 0,
        //   singleAmount: 0,
        //   title: "string",
        //   totalAmount: 0,
        // },
      ],
      activityStartTime: null,
      activityEndTime: null,
      prizeSettingList: [
        // 奖项设置
        {
          index: 0,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 1,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 2,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 3,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 4,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 5,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 6,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
        {
          index: 7,
          prizeType: 9,
          price: null,
          title: "谢谢参与",
          totalAmount: null,
          dailyLimit:null,
          percentage: null,
        },
      ],
      index: 0,
      theNum: 0,
      timeDay: 0, //活动持续天数
      timeOut: 0, //多少小时
      fileList: "",
      disableTime: false,
      extraPriceTask: [
        {
          interests: false,
          interestsVal: ''
        },
        {
          newCustomer: false,
          newCustomerVal: ''
        },
        {
          oldCustomer: false,
          oldCustomerVal: ''
        },
        {
          member: false,
          memberVal: ''
        },
        {
          preSale: false,
          preSaleVal: '',
          time: [],
          handinCondition: 0,
          feedBackCondition: 0,
          handinConditionList: [],
          selectGoodsStateFilter: false,
          handinConditionListEx: [],
          selectGoodsStateFilterEx: false
          // rules: {
          //   timeAndPreSaleVal: [
          //     { required: true, message: '请填写时间和预售定金值', trigger: 'blur' },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (!value.time || !value.preSaleVal) {
          //           callback(new Error('请填写时间和预售定金值'));
          //         } else {
          //           callback();
          //         }
          //       },
          //       trigger: 'blur'
          //     }
          //   ]
          // }
        },
        {
          costPayFeedback: false,
          time: [],
          handinCondition: 0,
          feedBackCondition: 0,
          timesCondition1: '',
          timesCondition2: '',
          handinConditionList: [],
          selectGoodsStateFilter: false,
          handinConditionListEx: [],
          selectGoodsStateFilterEx: false
          // rules: {
          //   timeAndPreSaleVal: [
          //     { required: true, message: '请填写时间和预售定金值', trigger: 'blur' },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (!value.time || !value.preSaleVal) {
          //           callback(new Error('请填写时间和预售定金值'));
          //         } else {
          //           callback();
          //         }
          //       },
          //       trigger: 'blur'
          //     }
          //   ]
          // }
        },
        {
          costReceiFeedback: false,
          time: [],
          handinCondition: 0,
          feedBackCondition: 0,
          timesCondition1: '',
          timesCondition2: '',
          handinConditionList: [],
          selectGoodsStateFilter: false,
          handinConditionListEx: [],
          selectGoodsStateFilterEx: false
          // rules: {
          //   timeAndPreSaleVal: [
          //     { required: true, message: '请填写时间和预售定金值', trigger: 'blur' },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (!value.time || !value.preSaleVal) {
          //           callback(new Error('请填写时间和预售定金值'));
          //         } else {
          //           callback();
          //         }
          //       },
          //       trigger: 'blur'
          //     }
          //   ]
          // }
        },
      ],
      REextraPriceTask: [
        {
          interests: false,
          interestsVal: ''
        },
        {
          newCustomer: false,
          newCustomerVal: ''
        },
        {
          oldCustomer: false,
          oldCustomerVal: ''
        },
        {
          member: false,
          memberVal: ''
        },
        {
          preSale: false,
          preSaleVal: '',
          time: [],
          handinCondition: 0,
          feedBackCondition: 0,
          handinConditionList: [],
          selectGoodsStateFilter: false,
          handinConditionListEx: [],
          selectGoodsStateFilterEx: false
          // rules: {
          //   timeAndPreSaleVal: [
          //     { required: true, message: '请填写时间和预售定金值', trigger: 'blur' },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (!value.time || !value.preSaleVal) {
          //           callback(new Error('请填写时间和预售定金值'));
          //         } else {
          //           callback();
          //         }
          //       },
          //       trigger: 'blur'
          //     }
          //   ]
          // }
        },
        {
          costPayFeedback: false,
          time: [],
          handinCondition: 0,
          feedBackCondition: 0,
          timesCondition1: '',
          timesCondition2: '',
          handinConditionList: [],
          selectGoodsStateFilter: false,
          handinConditionListEx: [],
          selectGoodsStateFilterEx: false
          // rules: {
          //   timeAndPreSaleVal: [
          //     { required: true, message: '请填写时间和预售定金值', trigger: 'blur' },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (!value.time || !value.preSaleVal) {
          //           callback(new Error('请填写时间和预售定金值'));
          //         } else {
          //           callback();
          //         }
          //       },
          //       trigger: 'blur'
          //     }
          //   ]
          // }
        },
        {
          costReceiFeedback: false,
          time: [],
          handinCondition: 0,
          feedBackCondition: 0,
          timesCondition1: '',
          timesCondition2: '',
          handinConditionList: [],
          selectGoodsStateFilter: false,
          handinConditionListEx: [],
          selectGoodsStateFilterEx: false
          // rules: {
          //   timeAndPreSaleVal: [
          //     { required: true, message: '请填写时间和预售定金值', trigger: 'blur' },
          //     {
          //       validator: (rule, value, callback) => {
          //         if (!value.time || !value.preSaleVal) {
          //           callback(new Error('请填写时间和预售定金值'));
          //         } else {
          //           callback();
          //         }
          //       },
          //       trigger: 'blur'
          //     }
          //   ]
          // }
        },
      ],
    };
  },
  created() {
    this.activityData = this.$route.query.activityData;
    console.log('this.$route.query------>', this.$route.query)
    if (this.$route.query.valueRow) {
      this.backgroundOpacity = this.$route.query.backgroundOpacity == "true" ? true : false;
      this.isSave = this.$route.query.isSave == "true" ? true : false;
      this.statusComment = this.$route.query.statusComment == "true" ? true : false;
      this.isStartEdit = this.$route.query.isStartEdit == "true" ? true : false;
      this.valueRow = this.$route.query.valueRow;
      this.activeValue = this.$route.query.activeValue;
      this.ids = this.valueRow.id;
    } else if (this.$route.query.copyParams) { // 复制
      this.isCopy = true
      this.backgroundOpacity = false;
      this.isSave = true;
      this.statusComment = true;
      this.isStartEdit = false;
      this.valueRow = this.$route.query.copyParams.valueRow;
      this.activeValue = this.$route.query.copyParams.activeValue;
      this.ids = this.valueRow.id;
    } 
    this.getDetail();
    this.getLevel()
  },

  methods: {
    // bigTurntable.giftDrawNumber
    isStartEditChange(e){
      if(!e){
        this.bigTurntable.giftDrawNumber = ''
      }
    },
    // bigTurntable.point
    isPointChange(e){
      if(!e){
        this.bigTurntable.point = ''
      }
    },
    isTaskchange(e){
      if(!e){
        this.extraPriceTask = JSON.parse(JSON.stringify(this.REextraPriceTask));
      }
    },
    taskListChange(e){
      if(e){
        this.isTask = true
      }
    },
    // 打开曝光商品弹窗
    exposureProducts() {
      console.log('666------>', 666)
      this.selectGoodsState = true;
      // console.log(this.itemListFor);
      if (this.itemListFor.length == 0) {
        this.itemListFor = [];
        this.mainImagelist = [];
        this.selectGoodsArr = [];
      }
      console.log('this.$refs.selectGo------>', this.$refs.selectGo)
      this.$refs.selectGo.handleRightCurrentChange(1);
    },
    // 选择曝光商品
    selectGoodsClose(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;
        if (index && index == 1) {
          this.itemListFor = newArr;
          this.mainImagelist = newArr;
          this.selectGoodsArr = newArr;
        }
      }
      this.selectGoodsState = false;
    },
    // 删除曝光商品
    delec(item, index) {
      let i = -1;
      this.mainImagelist.forEach((items, index1) => {
        if (items.skuId == item.skuId) i = index1;
      });
      console.log(i, 55555);
      if (i != -1) {
        this.mainImagelist.splice(i, 1);
        this.itemListFor = this.mainImagelist;
      }
      console.log(this.mainImagelist, 4444444);
    },
    // 曝光商品图片拖拽结束
    onEnd() {
      this.isDragging = false;
      //拖拽完成后的顺序
      let arr = [];
      console.log("this.mainImagelist)", this.mainImagelist);
      this.mainImagelist.forEach((item) => {
        // arr.push(item.wareId);
        arr.push(item.skuId);
        // this.draggingId = arr;
      });
    },

    //生成二维码
    qrcodeAll(val, queryId) {
      this.qrcode = new QRCode(queryId, {
        width: 117, // 设置宽度，单位像素
        height: 117, // 设置高度，单位像素
        text: val, // 设置二维码内容或跳转地址
      });
    },
    //输入框限制负数
    checkputn(e, row = {}, type = "nojingdou") {
      if (type == "nojingdou") {
        let filtered = e.target.value.replace(/^0|[^\d]/g, "");
        e.target.value = Number(filtered);
        // 不能输入0，绑定的值如果小于1，那么输入框置空
        if (e.target.value < 1) {
          e.target.value = "";
        }
      } else {
        if (row.quantityTotal && row.price && row.totalAmount) {
          let numTotal = this.$jingdouTotal({ ...row, prizeCount: row.totalAmount });
          if (!numTotal) {
            this.$message.warning("京豆总份额数量不能大于该京豆预算额！");
          }
          return numTotal;
        } else {
          return row.totalAmount;
        }
      }
    },
    checkLimitMount(row,min) {
      let newVal = (row.totalAmount+ "").replace(/[^\d]/g, '')
        if(newVal) {
          if(newVal<min) {
            return ""
          }else {
            if(Number(row.dailyLimit) > Number(row.totalAmount)) {
              this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
             return
            } else {
              return Number(row.totalAmount)
            }
          }
        }
    },
    checkLimit(row,min) {
        let newVal = (row.dailyLimit+ "").replace(/[^\d]/g, '')
        if(newVal) {
          if(newVal<min) {
            return ""
          }else {
            if(Number(row.dailyLimit) > Number(row.totalAmount)) {
              this.$message.warning("每日发放限额需小于等于奖品数量，请重新输入");
              return ""
            } else {
              return Number(row.dailyLimit)
            }
          }
        }
    },
    //上传图片
    handleChange(file, fileList) {
      const isLt3M = file.size < 1024 * 300;
      if (!isLt3M) {
        this.$message.error("上传图片大小不能超过 300K");
        this.$refs.upload.clearFiles();
      } else {
        this.$refs.upload.$children[1].$el.style.display = "none";
        // this.objectForm.name = file.name;
        let formdata = new FormData();
        formdata.append("file", file.raw);
        uploadpic(formdata).then((res) => {
          // 获取图片真实url
          this.fileList = res.data;
        });
      }
    },
    handleRemove(file, fileList) {
      // this.fileList = [];
      // this.$refs.upload.clearFiles();
      // this.form.logo = "";
      this.$refs.upload.$children[1].$el.style.display = "inline-block";
    },
    // changeImg(row) {
    //   console.log(row, 33333333333);
    // },
    httpRequest() {},
    //生成规则
    generateRule() {
      let oldValue = this.ruleForm;
      let text1 = "",
        text2 = "",
        text3 = "",
        text4 = "",
        text5 = "",
        text6 = "",
        text7 = "",
        text8 = "";
      //活动名称
      if (this.ruleForm.activityName.length > 0) {
        text1 = "活动名称：" + this.ruleForm.activityName;
      }
      //活动时间
      if (this.ruleForm.startTime && this.ruleForm.endTime) {
        text2 = "活动时间：" + this.ruleForm.startTime + "-" + this.ruleForm.endTime;
      }
      if (this.ruleForm.condFollow == true) {
        text3 = "活动条件：关注店铺后方可参加活动";
      }
      let text34 = ""
      if (this.ruleForm.activityObject == "1" && this.ruleForm.membershipTime && this.ruleForm.partner!=[0]){
        text34 = `入会时间：${this.ruleForm.membershipTime}之后入会的会员可参与活动`
      }
      if(this.isPoint&&this.bigTurntable.point){
          text4 = "抽奖条件：用户消耗" + this.bigTurntable.point + "积分抽奖一次";
      }
      if(this.isGift&&this.bigTurntable.giftDrawNumber){
        text4 =
            "抽奖条件："+
            "每日赠送" +
            this.bigTurntable.giftDrawNumber +
            "次抽奖机会（按自然日赠送）";
      }
      if (this.isGift&&this.isPoint) {
          text4 =
            "抽奖条件：用户消耗" +
            this.bigTurntable.point +
            "积分抽奖一次," +
            "每日赠送" +
            this.bigTurntable.giftDrawNumber +
            "次抽奖机会（按自然日赠送）";
      }
      if (this.bigTurntable.oneDayMaxDrawNumber && this.bigTurntable.totalMaxDrawNumber) {
        if (this.bigTurntable.oneDayMaxRewardNumber && this.bigTurntable.totalMaxRewardNumber) {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次，活动期间每人每天中奖不超过" +
            this.bigTurntable.oneDayMaxRewardNumber +
            "次, 累计中奖不超过" +
            this.bigTurntable.totalMaxRewardNumber +
            "次";
        } else if (this.bigTurntable.oneDayMaxRewardNumber) {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次，活动期间每人每天中奖不超过" +
            this.bigTurntable.oneDayMaxRewardNumber +
            "次, 累计中奖不限次";
        } else if (this.bigTurntable.totalMaxRewardNumber) {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次, 活动期间每人每天中奖不限次，累计中奖不超过" +
            this.bigTurntable.totalMaxRewardNumber +
            "次";
        } else {
          text5 =
            "抽奖和中奖限制：每人每天最多抽奖次数" +
            this.bigTurntable.oneDayMaxDrawNumber +
            "次，活动期间累计抽奖最多" +
            this.bigTurntable.totalMaxDrawNumber +
            "次";
        }
      }
      let Arr1 = [text1, text2, text3,text34, text4, text5, text6, text7, text8];
      let newText = "";
      let newNum = 1;
      Arr1.forEach((item) => {
        if (item.length > 0) {
          newText = newText + newNum + "." + item + ";" + "\n";
          newNum = newNum + 1;
        }
      });
      this.ruleForm.ruleDescription = newText;
    },
    // 活动进行中修改奖品数量
    beAdd(row){
      console.log("活动进行中修改奖品数量",row);
      if(this.isStartEdit){
        if(row.minNum && Number(row.totalAmount) < Number(row.minNum)){
          row.totalAmount = row.minNum
          this.$message.warning("为避免客诉，奖品数量不能小于之前哦~")
        }
      }
    },
    //清除
    cleanData(row) {
      if(this.isStartEdit) return;
      row.assetsId = null;
      row.prizeType = 9;
      row.price = null;
      row.title = "谢谢参与";
      row.logo = null;
      row.percentage = "";
      row.singleAmount = null;
      row.totalAmount = null;
      row.dailyLimit = null;
      this.winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          this.winningRate += Number(item.percentage);
        }
      });
      if (row.percentage) {
        this.winningRate = this.winningRate.toFixed(3);
      }
    },
    //选择奖品弹窗
    centerVis(row) {
      this.$refs.selectProduct.openDialog();
      this.JingdouCount.prizeCount = row.totalAmount;
      this.index = row.index;
      console.log("this.JingdouCount.prizeCount", this.JingdouCount.prizeCount);
      this.$refs.selectProduct.physicalGift(row)
    },
    // 返回上一步
    returnBack() {
      this.$emit("returnBack");
    },
    // 取消编辑
    cancelEdit() {
      this.$emit("cancelEdit");
    },
    // 获取奖品
    getTheData(data, prizeType) {
      console.log('prizeType------>', prizeType)
      console.log('data------>', data)
      if (data.couponType == 4) {
        this.generalCoupon = JSON.parse(JSON.stringify(data));
      } else {
        this.generalCoupon = { couponType: 0 };
      }
      if (prizeType == 1) {
        this.prizeSettingList[this.index].couponType = data.couponType;
        if (data.couponType == 4) {
          this.prizeSettingList[this.index].batchKey = data.batchKey;
        }
      }
      if (data.giftType) {
        this.prizeSettingList[this.index].giftType = Number(data.giftType);
      }

      if (data.couponType == 4) {
        this.prizeSettingList[this.index].price = Number(data.price);
      } else {
        this.prizeSettingList[this.index].price = Number(data.discount);
      }

      if (data.couponType == 4) {
        this.prizeSettingList[this.index].assetsId = null;
      } else {
        this.prizeSettingList[this.index].assetsId = Number(data.couponId);
      }

      this.prizeSettingList[this.index].logo = data.logo;
      this.prizeSettingList[this.index].prizeType = prizeType;
      if (prizeType == 4) {
        this.prizeSettingList[this.index].title = "店铺积分";
      } else {
        if (data.couponType == 4) {
          this.prizeSettingList[this.index].title = "优惠券";
        } else {
          this.prizeSettingList[this.index].title = data.name;
        }
      }
      if (data.singleAmount) {
        this.prizeSettingList[this.index].singleAmount = data.singleAmount;
      }
      if (prizeType == 2) {
        this.prizeSettingList[this.index].quantityTotal = data.quantityTotal;
      }
      if (prizeType == 10) {
        this.prizeSettingList[this.index].price = data.price;
        this.prizeSettingList[this.index].title = data.itemTitle;
        this.prizeSettingList[this.index].title = data.itemTitle.length >= 12 ? data.itemTitle.substring(0, 12) : data.itemTitle;
        this.prizeSettingList[this.index].logo = data.picUrl;
        this.prizeSettingList[this.index].assetsId = data.id;
        this.prizeSettingList[this.index].singleAmount = 1;
      }
      // 订单备注开启单独处理，只针对大转盘
      if (prizeType == 3 && data.prizeRemarkType && this.activityData.id == 8) {
        this.prizeSettingList[this.index].prizeRemarkType = data.prizeRemarkType;
        this.prizeSettingList[this.index].receivePayment = data.receivePayment;
        this.prizeSettingList[this.index].tradeLimitTime = data.tradeLimitTime;
        this.prizeSettingList[this.index].tradeLimitTimeUnit = data.tradeLimitTimeUnit;
        this.prizeSettingList[this.index].itemType = data.itemType;
        this.prizeSettingList[this.index].tradeFlag = data.tradeFlag;
        this.prizeSettingList[this.index].content = data.content;

        if (data.itemType) {
          const arr = data.goodsList.map(item => item.wareId)
          this.prizeSettingList[this.index].numIid = arr.join(",");
        } else {
          this.prizeSettingList[this.index].numIid = "";
        }
      }
      console.log('this.prizeSettingList------>', this.prizeSettingList)
    },
    //深拷贝
    deepClone(obj) {
      let theObj = JSON.stringify(obj),
        objClone = JSON.parse(theObj);
      return objClone;
    },

    // 下一步
    resetForm() {
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      console.log(this.prizeSettingList, "obj");
      if (!this.ruleForm.activityName) {
        this.$message.warning("请输入活动名称");
        return;
      }
      //活动时间的限制
      if (!this.ruleForm.startTime || !this.ruleForm.endTime) {
        this.$message.warning("请输入活动时间");
        return;
      }
      if (!this.isTask&&!this.isPoint&&!this.isGift) {
        this.$message.warning("请选择抽奖条件");
        return;
      }
      let isgo = true
      if (this.isTask) {
        if (
          !this.extraPriceTask[0].interests &&
          !this.extraPriceTask[1].newCustomer &&
          !this.extraPriceTask[2].oldCustomer &&
          !this.extraPriceTask[3].member &&
          !this.extraPriceTask[4].preSale &&
          !this.extraPriceTask[5].costPayFeedback &&
          !this.extraPriceTask[6].costReceiFeedback
        ) {
          this.$message.warning("请选择额外抽奖任务");
          return;
        }
      }
      if (this.isPoint) {
        if (!this.bigTurntable.point) {
          isgo = false
        }
      }
      if (this.isGift) {
        if (!this.bigTurntable.giftDrawNumber) {
          isgo = false
        }
      }
      if(!isgo){
        this.$message.warning("请输入抽奖条件");
        return;
      }
      if (this.ruleForm.exposureSwitch&&!this.itemListFor.length) {
        this.$message.warning("请选择曝光商品");
        return;
      }
      if (!this.ruleForm.ruleDescription) {
        this.$message.warning("请输入活动规则");
        return;
      }
      
      if(this.extraPriceTask[0].interests&&!this.extraPriceTask[0].interestsVal){
        this.$message.warning("请输入关注店铺后赠送抽奖机会次数")
        return
      }
      if(this.extraPriceTask[1].newCustomer&&!this.extraPriceTask[1].newCustomerVal){
        this.$message.warning("请输入新客赠送抽奖机会次数")
        return
      }
      if(this.extraPriceTask[2].oldCustomer&&!this.extraPriceTask[2].oldCustomerVal){
        this.$message.warning("请输入老客赠送抽奖机会次数")
        return
      }
      if(this.extraPriceTask[3].member&&!this.extraPriceTask[3].memberVal){
        this.$message.warning("请输入会员赠送抽奖机会次数")
        return
      }
      if(this.extraPriceTask[4].preSale){
        if(!(this.extraPriceTask[4].time&&this.extraPriceTask[4].time.length&&this.extraPriceTask[4].preSaleVal)){
          this.$message.warning("请输入 预售商品支付定金赠送 赠送说明时间和赠送次数")
          return
        }
        if(this.extraPriceTask[4].handinCondition ==1&&!(this.extraPriceTask[4].handinConditionList&&this.extraPriceTask[4].handinConditionList.length)){
          this.$message.warning("请选择预售商品支付定金赠送单笔订单包含商品")
          return
        }
        if(this.extraPriceTask[4].handinCondition ==2&&!(this.extraPriceTask[4].handinConditionListEx&&this.extraPriceTask[4].handinConditionListEx.length)){
          this.$message.warning("请选择预售商品支付定金赠送单笔订单排除商品")
          return
        }
      }
      if(this.extraPriceTask[5].costPayFeedback){
        if(!(this.extraPriceTask[5].time&&this.extraPriceTask[5].time.length)){
          this.$message.warning("请输入 消费赠送（已付款）赠送说明时间")
          return
        }
        if(this.extraPriceTask[5].handinCondition ==1&&!(this.extraPriceTask[5].handinConditionList&&this.extraPriceTask[5].handinConditionList.length)){
          this.$message.warning("请选择消费赠送（已付款）单笔订单包含商品")
          return
        }
        if(this.extraPriceTask[5].handinCondition ==2&&!(this.extraPriceTask[5].handinConditionListEx&&this.extraPriceTask[5].handinConditionListEx.length)){
          this.$message.warning("请选择消费赠送（已付款）单笔订单排除商品")
          return
        }
        if(!this.extraPriceTask[5].timesCondition1){
          this.$message.warning("请选择消费赠送（已付款）单笔订单实付金额")
          return
        }
        if(!this.extraPriceTask[5].timesCondition2){
          this.$message.warning("请选择消费赠送（已付款）单笔订单实付金额固定赠送抽奖次数")
          return
        }
      }
      if(this.extraPriceTask[6].costReceiFeedback){
        if(!(this.extraPriceTask[6].time&&this.extraPriceTask[6].time.length)){
          this.$message.warning("请输入 消费赠送（已收货） 赠送说明时间")
          return
        }
        if(this.extraPriceTask[6].handinCondition ==1&&!(this.extraPriceTask[6].handinConditionList&&this.extraPriceTask[6].handinConditionList.length)){
          this.$message.warning("请选择消费赠送（已收货）单笔订单包含商品")
          return
        }
        if(this.extraPriceTask[6].handinCondition ==2&&!(this.extraPriceTask[6].handinConditionListEx&&this.extraPriceTask[6].handinConditionListEx.length)){
          this.$message.warning("请选择消费赠送（已收货）单笔订单排除商品")
          return
        }
        if(!this.extraPriceTask[6].timesCondition1){
          this.$message.warning("请选择消费赠送（已收货）单笔订单实付金额")
          return
        }
        if(!this.extraPriceTask[6].timesCondition2){
          this.$message.warning("请选择消费赠送（已收货）单笔订单实付金额固定赠送抽奖次数")
          return
        }
      }
      this.joinBlackList = true;
    },
    handleDialogCloseAnoth() {
      let obj = {};
      obj = this.deepClone(this.ruleForm);
      obj.condFollow = Number(this.ruleForm.condFollow);
      obj.seniorGroupId = this.peopleList.join(","), //指定人群
      obj.allowLevel = this.ruleForm.partner.join(","), //参与会员等级：-1(全部)，0(非会员)，其余填会员等级,
      //Note每日赠送
      // obj.isGift = Number(this.ruleForm.isGift);
      obj.bigTurntableDrawRuleDTO = this.bigTurntable;
      obj.bigTurntableDrawRuleDTO.isGift = this.isGift;
      obj.bigTurntableDrawRuleDTO.isTask = this.isTask
      obj.bigTurntableDrawRuleDTO.isPoint = this.isPoint
      obj.bigTurntableDrawPrizeDTOS = this.deepClone(this.prizeSettingList);
      obj.bigTurntableDrawPrizeDTOS.forEach((item, index) => {
        item.percentage = Number(item.percentage);
      });
      obj.isExposureItem = this.ruleForm.exposureSwitch ? 1 : 0,
      obj.templateId = this.activityData.templateId
      obj.itemList = this.itemListFor.map((item) => {
        return {
          logo: item.logo,
          price: item.price,
          title: item.title,
          skuId: item.skuId,
          wareId: item.numIid,
        };
      })
      obj.taskList = []
      if(this.extraPriceTask[0].interests == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 6,
          taskValidity: 1,
          giftNumber: this.extraPriceTask[0].interestsVal
        })
      }
      if(this.extraPriceTask[1].newCustomer == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 10,
          taskValidity: 1,
          giftNumber: this.extraPriceTask[1].newCustomerVal
        })
      }
      if(this.extraPriceTask[2].oldCustomer == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 11,
          taskValidity: 1,
          giftNumber: this.extraPriceTask[2].oldCustomerVal
        })
      }
      if(this.extraPriceTask[3].member == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 7,
          taskValidity: 1,
          giftNumber: this.extraPriceTask[3].memberVal
        })
      }
      if(this.extraPriceTask[4].preSale == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 12,
          taskValidity: 1,
          giftNumber: this.extraPriceTask[4].preSaleVal,
          orderStartTime: this.extraPriceTask[4].time[0],
          orderEndTime: this.extraPriceTask[4].time[1],
          itemType: this.extraPriceTask[4].handinCondition,
          giftLimit: this.extraPriceTask[4].feedBackCondition,
          skuIds: this.extraPriceTask[4].handinCondition == 0?[]:this.extraPriceTask[4].handinCondition == 1?this.extraPriceTask[4].handinConditionList:this.extraPriceTask[4].handinConditionListEx
        })
      }
      if(this.extraPriceTask[5].costPayFeedback == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 13,
          taskValidity: 1,
          orderStartTime: this.extraPriceTask[5].time[0],
          orderEndTime: this.extraPriceTask[5].time[1],
          itemType: this.extraPriceTask[5].handinCondition,
          giftLimit: this.extraPriceTask[5].feedBackCondition,
          skuIds: this.extraPriceTask[5].handinCondition == 0?[]:this.extraPriceTask[5].handinCondition == 1?this.extraPriceTask[5].handinConditionList:this.extraPriceTask[5].handinConditionListEx,
          startPayment: String(this.extraPriceTask[5].timesCondition1),
          giftNumber: Number(this.extraPriceTask[5].timesCondition2)
        })
      }
      if(this.extraPriceTask[6].costReceiFeedback == true){
        obj.taskList.push({
          activityType: 2,
          taskType: 14,
          taskValidity: 1,
          orderStartTime: this.extraPriceTask[6].time[0],
          orderEndTime: this.extraPriceTask[6].time[1],
          itemType: this.extraPriceTask[6].handinCondition,
          giftLimit: this.extraPriceTask[6].feedBackCondition,
          skuIds: this.extraPriceTask[6].handinCondition == 0?[]:this.extraPriceTask[6].handinCondition == 1?this.extraPriceTask[6].handinConditionList:this.extraPriceTask[6].handinConditionListEx,
          startPayment: String(this.extraPriceTask[6].timesCondition1),
          giftNumber: Number(this.extraPriceTask[6].timesCondition2)
        })
      }
      if (this.checked == true) {
        if (this.ids == "" || this.isCopy) {
          if (this.isCopy) {
            delete obj.id
            delete obj.templateJson
          }
          bigTurntableDraw(obj)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                // let routeUrl = this.$router.resolve({
                //   path: "/integralCenter/integralEden",
                //   query: { tabAct: 3 },
                // });
                // window.open(routeUrl.href, "_self");
                this.$router.push({ path: "activeList2" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        } else {
          modifyBigTurn(obj)
            .then((res) => {
              if (res && res.code == 1) {
                this.joinBlackList = false;
                // let routeUrl = this.$router.resolve({
                //   path: "/integralCenter/integralEden",
                //   query: { tabAct: 3 },
                // });
                // window.open(routeUrl.href, "_self");
                this.$router.push({ path: "activeList2" });
                this.$message.success(res.message);
              } else {
                this.$message.error(res.message);
              }
            })
            .catch((res) => {});
        }
        // console.log(this.prizeSettingList, "obj");
        // this.$emit("saveEdit");
      } else {
        this.$message.info("请勾选明确活动规则后即可创建");
        return;
      }
    },
    //获取活动详情
    getDetail() {
      if (this.ids != "") {
        let id = this.ids;
        getbigTurn(id)
          .then((res) => {
            res.data.exposureSwitch = false
            console.log([String(res.data.startTime), String(res.data.endTime)]);
            console.log("res.data",res.data)
            res.data.partner = ['-1']
            this.ruleForm = res.data;
            if (this.isCopy) {
              this.ruleForm.ruleDescription = ""
            }
            this.ruleForm.condFollow = Boolean(res.data.condFollow);
            this.isGift = res.data.bigTurntableDrawRuleDTO.isGift;
            this.isPoint = res.data.bigTurntableDrawRuleDTO.isPoint
            this.isTask = res.data.bigTurntableDrawRuleDTO.isTask
            this.bigTurntable = res.data.bigTurntableDrawRuleDTO;
            if (!this.isCopy) {
              this.prizeSettingList = res.data.bigTurntableDrawPrizeDTOS;
              this.prizeSettingList.forEach(item=>item.minNum=item.totalAmount)
            } else {
              this.prizeSettingList = [
                // 奖项设置
                {
                  index: 0,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 1,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 2,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 3,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 4,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 5,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 6,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
                {
                  index: 7,
                  prizeType: 9,
                  price: null,
                  title: "谢谢参与",
                  totalAmount: null,
                  percentage: null,
                },
              ]
            }

          //活动对象
          this.ruleForm.membershipTime = res.data.membershipTime
          this.ruleForm.activityObject = res.data.activityObject || 0;
          this.ruleForm.newOldCustomer = res.data.newOldCustomer || 0;
          this.peopleList = res.data.seniorGroupId
            ? res.data.seniorGroupId.split(",")
            : [];
          if (res.data.allowLevel) {
            this.ruleForm.partner = res.data.allowLevel.split(",");
          }

            
            this.ruleForm.exposureSwitch = res.data.isExposureItem == 0 ? false : true;
            let shopList = res.data.itemList
            ? res.data.itemList.map((item) => {
              return {
                ...item,
                numIid: item.wareId,
                itemTitle: item.title,
                picUrl: item.logo,
              };
            })
          : [];
          this.selectGoodsArr = shopList;
          this.itemListFor = shopList;
          this.mainImagelist = shopList;
            this.prizeSettingList.forEach((item, index) => {
              item.index = index;
            });
            console.log('this.prizeSettingList------>', this.prizeSettingList)
            this.prizeSettingList.forEach((item) => {
              if (item.percentage) {
                this.winningRate += Number(item.percentage);
              }
              if (item.prizeRemarkType) {
                item.prizeRemarkType = item.prizeRemarkType;
                item.receivePayment = item.pointActivityPrizeRemark.receivePayment;
                item.tradeLimitTime = item.pointActivityPrizeRemark.tradeLimitTime;
                item.tradeLimitTimeUnit = item.pointActivityPrizeRemark.tradeLimitTimeUnit;
                item.itemType = item.pointActivityPrizeRemark.itemType;
                item.tradeFlag = item.pointActivityPrizeRemark.tradeFlag;
                item.content = item.pointActivityPrizeRemark.content;
                item.numIid = item.pointActivityPrizeRemark.numIid;
                delete item.pointActivityPrizeRemark
              }
            });

            this.activityTimeValue = [String(res.data.startTime), String(res.data.endTime)];
            this.winningRate = this.winningRate.toFixed(3);
       
            if(this.isStartEdit){
              //进行中活动 无法修改活动开启时间
              this.isStartEditTime = String(res.data.startTime)
            }

            //Note每日赠送
            // 6关注店铺 10新客赠送 11老客赠送 7会员 12预售商品支付定金赠送 13消费赠送（已收款） 14消费赠送（已收货）
            if(res.data.taskList&&res.data.taskList.length){
              res.data.taskList.forEach(el=>{
                if(el.taskType==6){
                  this.extraPriceTask[0].interests = true
                  this.extraPriceTask[0].interestsVal = el.giftNumber
                }
                if(el.taskType==10){
                  this.extraPriceTask[1].newCustomer = true
                  this.extraPriceTask[1].newCustomerVal = el.giftNumber
                }
                if(el.taskType==11){
                  this.extraPriceTask[2].oldCustomer = true
                  this.extraPriceTask[2].oldCustomerVal = el.giftNumber
                }
                if(el.taskType==7){
                  this.extraPriceTask[3].member = true
                  this.extraPriceTask[3].memberVal = el.giftNumber
                }
                if(el.taskType==12){
                  this.extraPriceTask[4].preSale = true
                  this.extraPriceTask[4].preSaleVal = el.giftNumber
                  this.extraPriceTask[4].time = [el.orderStartTime,el.orderEndTime]
                  this.extraPriceTask[4].handinCondition = el.itemType
                  this.extraPriceTask[4].feedBackCondition = el.giftLimit
                  if(el.itemType==0){
                    this.extraPriceTask[4].handinConditionList = []
                  }
                  if(el.itemType==1){
                    this.extraPriceTask[4].handinConditionList = el.skuIds
                  }
                  if(el.itemType==2){
                    this.extraPriceTask[4].handinConditionListEx = el.skuIds
                  }
                }
                if(el.taskType==13){
                  this.extraPriceTask[5].costPayFeedback = true
                  this.extraPriceTask[5].time = [el.orderStartTime,el.orderEndTime]
                  this.extraPriceTask[5].handinCondition = el.itemType
                  this.extraPriceTask[5].feedBackCondition = el.giftLimit
                  if(el.itemType==0){
                    this.extraPriceTask[5].handinConditionList = []
                  }
                  if(el.itemType==1){
                    this.extraPriceTask[5].handinConditionList = el.skuIds
                  }
                  if(el.itemType==2){
                    this.extraPriceTask[5].handinConditionListEx = el.skuIds
                  }
                  this.extraPriceTask[5].timesCondition1 = el.startPayment
                  this.extraPriceTask[5].timesCondition2 = el.giftNumber
                }
                if(el.taskType==14){
                  this.extraPriceTask[6].costReceiFeedback = true
                  this.extraPriceTask[6].time = [el.orderStartTime,el.orderEndTime]
                  this.extraPriceTask[6].handinCondition = el.itemType
                  this.extraPriceTask[6].feedBackCondition = el.giftLimit
                  if(el.itemType==0){
                    this.extraPriceTask[6].handinConditionList = []
                  }
                  if(el.itemType==1){
                    this.extraPriceTask[6].handinConditionList = el.skuIds
                  }
                  if(el.itemType==2){
                    this.extraPriceTask[6].handinConditionListEx = el.skuIds
                  }
                  this.extraPriceTask[6].timesCondition1 = el.startPayment
                  this.extraPriceTask[6].timesCondition2 = el.giftNumber
                }
              })
            }
            console.log([String(res.data.startTime), String(res.data.endTime)]);
            console.log("this.activityTimeValue", this.activityTimeValue);
            this.activityTimeChange();
          })
          .catch((res) => {});
      } else {
        this.activityTimeChange();
      }
    },

    //会员等级
    getLevel() {
      querymemberLevel()
        .then((res) => {
          console.log(res, 6667);
          res.data.forEach((item) => {
            this.levelList.push(item.customerLevelName);
          });
          console.log(this.levelList, 111112);
        })
        .catch(() => {});
    },
    //选中改变
    checkListchange(val) {
      val.forEach((low) => {
        if (low == -1) {
          this.ruleForm.partner = ["-1"];
        }
      });
    },
    //活动对象切换
    handleActivityObj() {
      this.ruleForm.newOldCustomer = 0;
      this.ruleForm.partner = ["-1"];
      this.peopleList = [];
    },
    //选择人群回调
    handleConfirm(list) {
      console.log("选择人群", list);
      // let flag = false;
      // list.forEach((item) => {
      //   if (item.buyerNum == 0) {
      //     flag = true;
      //   }
      // });
      // if (flag) {
      //   this.$message.warning("含人群数量为0的人群，请重新选择人群");
      // }
      this.peopleList = list;
    },

    //清空时间
    clearTime() {
      this.ruleForm.startTime = "";
      this.ruleForm.endTime = "";
    },
    // 活动时间改变
    activityTimeChange(val) {
      if(this.isStartEdit){
        //进行中活动 无法修改活动开启时间
        this.activityTimeValue[0]= this.isStartEditTime
      }
      this.ruleForm.startTime = this.activityTimeValue[0];
      this.ruleForm.endTime = this.activityTimeValue[1];
      let nowTime = new Date().getTime();
      let start = new Date(this.ruleForm.startTime).valueOf();
      let end = new Date(this.ruleForm.endTime).valueOf();
      let invalidateDate = new Date(this.$store.state.loginUserInfo.expiredIn).valueOf();

      var datas, change1, change2, days, daysStart, daysEnd, date3;
      daysStart = this.ruleForm.startTime.substring(0, 10);
      daysEnd = this.ruleForm.endTime.substring(0, 10);
      if (this.ruleForm.endTime != "" && this.ruleForm.startTime != "") {
        datas = daysEnd.split("-");
        change1 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        datas = daysStart.split("-");
        change2 = new Date(datas[1] + "/" + datas[2] + "/" + datas[0]);
        days = parseInt(Math.abs(change1 - change2) / 1000 / 60 / 60 / 24);
        this.timeDay = days;
        //计算小时
        date3 = new Date(this.ruleForm.endTime).getTime() - new Date(this.ruleForm.startTime).getTime();
        var leave1 = date3 % (24 * 3600 * 1000);
        this.timeOut = Math.floor(leave1 / (3600 * 1000));
      } else {
        this.timeOut = 0;
      }

      if (this.backgroundOpacity) return;
      if (start < nowTime) {
        if (this.ids) {
          this.disableTime = true;
        } else {
          this.$message.warning("开始时间不能小于当前时间");
          // this.ruleForm.startTime = null;
          // return;
        }
      }
      if (end < nowTime) {
        this.$message.warning("结束时间不能小于当前时间");
        // this.ruleForm.endTime = null;
        // return;
      }
      if (end < start) {
        this.$message.warning("结束时间不能小于开始时间");
        // this.activityTimeValue[1] = "";
        // this.ruleForm.endTime = null;
        return;
      }
      if (end > invalidateDate) {
        this.$message.warning("活动时间不能超过软件有效期，请重新选择");
        this.activityTimeValue[1] = "";
        this.ruleForm.endTime = null;
        return;
      }
    },

    // 选择礼品
    choosegifts() {},
    // 保留小数点后两位
    oninput2(val) {
      // debugger
      if (val < 0) {
        val = "";
      } else if (val > 100) {
        val = "100";
      }

      let winningRate = 0;
      this.prizeSettingList.forEach((item) => {
        if (item.percentage) {
          winningRate += Number(item.percentage);
        }
      });

      if (winningRate > 100) {
        val = String(100 - (winningRate - val));
      } else if (winningRate == 100) {
        if (val >= 100) {
          val = "100";
        } else {
          val = String(100 - (winningRate - val));
          if (val == 0) {
            val = "";
          }
        }
      }
      // if (val == 0) {
      //   val = "";
      // }
      val = val.substring(0, 10);

      this.theNum++;
      return val ? val.replace(/^(\-)*(\d+)\.(\d\d\d).*$/, "$1$2.$3") : "";
    },
    oninput(val) {
      if (val && val <= 0) {
        val = "1";
      }
      return val;
    },
    clickLocalStep() {
      sessionStorage.setItem("goBack", this.activityData.goIndex);
      if (this.$route.query.copyParams && this.$route.query.copyParams.isCopy) {
        sessionStorage.setItem("goBackCopy", true);
      }
      this.$router.go(-1);
      // if (this.backgroundOpacity) {
      //   this.$emit("returnBack");
      //   return;
      // }
      // this.localStepNum = 0;
    },
    // 品牌定制弹窗
    handleOpen() {
      const href = "tencent://message/?uin=800152084&Site=%E5%9C%A8%E7%BA%BF%E5%AE%A2%E6%9C%8D&Menu=yes";
      window.open(href, "_self");
    },
    exposureProductsFiter(num){
      this.extraPriceTask[num].selectGoodsStateFilter = true
    },
    exposureProductsFiterEx(num){
      this.extraPriceTask[num].selectGoodsStateFilterEx = true
    },
    //选择商品数据 曝光
    selectTask4GoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.extraPriceTask[4].handinConditionList = newArr
        }
      }
      this.extraPriceTask[4].selectGoodsStateFilter = false;
    },
    selectTask4GoodsCloseFilterEx(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.extraPriceTask[4].handinConditionListEx = newArr
        }
      }
      this.extraPriceTask[4].selectGoodsStateFilterEx = false;
    },
    selectTask5GoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.extraPriceTask[5].handinConditionList = newArr
        }
      }
      this.extraPriceTask[5].selectGoodsStateFilter = false;
    },
    selectTask5GoodsCloseFilterEx(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.extraPriceTask[5].handinConditionListEx = newArr
        }
      }
      this.extraPriceTask[5].selectGoodsStateFilterEx = false;
    },
    selectTask6GoodsCloseFilter(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.extraPriceTask[6].handinConditionList = newArr
        }
      }
      this.extraPriceTask[6].selectGoodsStateFilter = false;
    },
    selectTask6GoodsCloseFilterEx(event, index) {
      if (typeof event != "boolean") {
        let newArr = event;

        if (index && index == 1) {
          this.extraPriceTask[6].handinConditionListEx = newArr
        }
      }
      this.extraPriceTask[6].selectGoodsStateFilterEx = false;
    },
  },
};
</script>

<style lang="scss" scoped>
.createPlayStep {
  min-width: 1046px;
  position: relative;
  box-sizing: border-box;
  min-height: 80vh;
  height: 88.5vh;
  background-color: #fff;
  // box-shadow: 0px 4px 8px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  margin: 24px;
  .headReturn {
    box-sizing: border-box;
    padding-left: 30px;
    width: 100%;
    height: 50px;
    line-height: 49px;
    border-bottom: 1px solid #f3f3f3;
    span {
      color: #ccc;
      cursor: pointer;
    }
    .name {
      color: #333;
      cursor: default;
    }
  }
  .step {
    padding: 30px 24px 0;
    .bz {
      display: flex;
      justify-content: center;
      height: 18px;
      // border-bottom: 1px solid #f3f3f3;
    }
  }
  .firststep {
    min-height: 720px;
    box-sizing: border-box;
    padding: 35px 35px 0;
    .itemList {
      display: flex;
      .item {
        box-sizing: border-box;
        position: relative;
        color: #666;
        text-align: center;
        padding: 6px;
        &:hover {
          .border::before,
          .border::after {
            opacity: 1;
            transform: scale(1);
          }
        }
        .border {
          position: absolute;
          left: 0;
          top: 0;
          width: 100%;
          height: 100%;
          border-radius: 4px;
          &::before,
          &::after {
            position: absolute;
            top: 0;
            right: 0;
            bottom: 0;
            left: 0;
            content: "";
            opacity: 0;
            pointer-events: none;
            transition: opacity 0.8s, transform 0.8s;
            border-radius: 4px;
          }
          &::before {
            border-top: 1px solid #2670fb;
            border-bottom: 1px solid #2670fb;
            -webkit-transform: scale(0, 1);
            transform: scale(0, 1);
          }
          &::after {
            border-right: 1px solid #2670fb;
            border-left: 1px solid #2670fb;
            -webkit-transform: scale(1, 0);
            transform: scale(1, 0);
          }
        }
        .wrapper {
          position: relative;
          height: 350px;
          border-radius: 6px;
          overflow: hidden;
          &:hover {
            .mask {
              opacity: 1;
            }
          }
          .mask {
            display: flex;
            flex-direction: column;
            justify-content: center;
            position: absolute;
            left: 0;
            top: 0;
            right: 0;
            bottom: 0;
            background-color: rgba(0, 0, 0, 0.6);
            color: #fff;
            opacity: 0;
            transition: all 0.2s;
            .img {
              max-width: 130px;
              margin: 0 auto 30px;
              .imgBg {
                box-sizing: border-box;
                height: 129px;
                width: 129px;
                padding: 6px;
                border-radius: 6px;
                background-color: #fff;
              }
              .tpl {
                display: inline-block;
                margin-top: 4px;
                opacity: 0.7;
              }
            }
          }
        }
      }
    }
  }
  .secondstep {
    box-sizing: border-box;
    position: relative;
    padding: 0px 28px 1px 24px;
    // margin-bottom: 29px;
    .zd {
      width: 360px;
    }
    .time2 {
      width: 54px;
      height: 28px;
      border-radius: 4px;
      display: inline-block;
      text-align: center;
      line-height: 28px;
    }
    .lastTime {
      margin-left: 20px;
      font-size: 14px;
      i {
        color: #ccc;
      }
    }
    .limit {
      display: flex;
      flex-direction: column;
      p {
        margin: 0;
        &:nth-child(2) {
          margin: 16px 0;
        }
      }
      .c {
        color: #2670fb;
      }
      .desc {
        i {
          opacity: 0.7;
          color: #2670fb;
        }
        color: #999;
      }
      /deep/ .el-input {
        margin: 0 6px;
      }
    }
    .img {
      display: inline-block;
      width: 40px;
      height: 40px;
      border-radius: 50%;
      background-color: #eeeeee;
    }
    .tips {
      display: flex;
      flex-direction: column;
      margin-top: 16px;
      box-sizing: border-box;
      padding: 10px 30px;
      background: #f4f7ff;
      font-size: 13px;
      color: #333;
      p {
        margin: 0;
        line-height: 20px;
        padding-left: 18px;
      }
    }
    .generate {
      width: 76px;
      margin: 8px 8px 0 0;
      background: rgba(38, 112, 251, 0.1);
      border: 1px solid #2670fb;
      color: #2670fb;
      border-radius: 4px;
    }
    .termAdd {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 6px;
      color: #333;
      p {
        margin: 0;
      }
      .add {
        margin-left: 4px;
        color: #2670fb;
      }
    }
    .set {
      display: inline-block;
      // margin-top: 30px;
    }
    .desc {
      margin-left: 8px;
      color: #999;
      font-size: 13px;
      i {
        // color: #fe8f8a;
        // opacity: 0.7;
        font-size: 13px;
      }
    }
    .s {
      color: #2670fb;
      cursor: pointer;
    }
    .returnBtn {
      width: 148px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(254, 77, 69, 1);
      color: #2670fb;
      transition: all 0.2s;
      &:hover {
        background-color: #2670fb;
        color: #fff;
      }
    }
    .keepBtn {
      margin-left: 30px;
      width: 188px;
      background-color: #2670fb;
      color: #fff;
      transition: all 0.2s;
      &:hover {
        opacity: 0.9;
      }
    }
    // /deep/ .el-table .el-table__header-wrapper th .cell {
    //   // text-align: center;
    //   font-weight: 500;
    // }
    // /deep/ .el-table .el-table__header-wrapper th {
    //   // border-right: 1px solid #f0f0f0;
    //   &:last-child {
    //     border-right: none;
    //   }
    // }
    // /deep/ .el-table--enable-row-transition .el-table__body td {
    //   text-align: center;
    //   // border-right: 1px solid #f0f0f0;
    //   &:last-child {
    //     border-right: none;
    //   }
    // }
  }
}
.wrapper-kaika {
  width: 100%;
  height: 100%;
  display: grid;
  // align-items: center;
  // justify-content: center;

  &-img {
    background-color: #fafafa;
    border: 2px solid rgba(254, 77, 69, 0.0784313725490196);
    border-radius: 8px;
    height: 350px;
    // margin-right: 20px;
    position: relative;
    &:hover {
      .borderkaika::before,
      .borderkaika::after {
        opacity: 1;
        transform: scale(1);
      }
    }
    .borderkaika {
      position: absolute;
      left: -6px;
      top: -6px;
      width: 218px;
      height: 360px;
      border-radius: 4px;
      &::before,
      &::after {
        position: absolute;
        top: 0;
        right: 0;
        bottom: 0;
        left: 0;
        content: "";
        opacity: 0;
        pointer-events: none;
        transition: opacity 0.8s, transform 0.8s;
        border-radius: 4px;
      }
      &::before {
        border-top: 1px solid #2670fb;
        border-bottom: 1px solid #2670fb;
        -webkit-transform: scale(0, 1);
        transform: scale(0, 1);
      }
      &::after {
        border-right: 1px solid #2670fb;
        border-left: 1px solid #2670fb;
        -webkit-transform: scale(1, 0);
        transform: scale(1, 0);
      }
    }

    div {
      font-size: 18px;
      font-weight: bold;
      // line-height: 25px;
      color: #333333;
    }
    img {
      width: 32px;
      height: 32px;
    }

    .queryIdIMG {
      display: none;
    }
    &:hover {
      .queryIdIMG {
        display: block;
      }
      .mask {
        opacity: 1;
      }
    }
    .mask {
      display: flex;
      flex-direction: column;
      justify-content: center;
      position: absolute;
      left: 0;
      top: 0;
      right: 0;
      bottom: 0;
      background-color: rgba(0, 0, 0, 0.6);
      color: #fff;
      opacity: 0;
      transition: all 0.2s;
      .img {
        max-width: 130px;
        margin: 0 auto 30px;
        .imgBg {
          box-sizing: border-box;
          height: 129px;
          width: 129px;
          padding: 6px;
          border-radius: 6px;
          background-color: #fff;
        }
        .tpl {
          display: inline-block;
          font-size: 14px;
          color: #fff;
          margin-top: 10px;
          // opacity: 0.7;
        }
      }
    }
  }
  &-tanchuang {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
  .lijijq {
    &::after {
      content: "立即领取";
      display: block;
      position: absolute;
      bottom: 9px;
      left: 51%;
      transform: translateX(-50%);
      font-size: 14px;
      font-family: system-ui;
      font-weight: bold;
      color: #ed6e09;
      text-shadow: 0 0 black;
    }
  }
}
</style>
